/* global I18n */

import React, {useRef} from "react"
import KenhubModal from "../kenhub_modal"
import FaIcon from "../fa_icon"
import {notify_now} from "../../notify"
import signals from "../../signals"

function ShareQuizModal({on_close, is_open, quiz}) {
  const ref = useRef(null)

  function copy_to_clipboard() {
    if (ref.current) {
      navigator.clipboard.writeText(ref.current.value)
      notify_now(I18n.t("js.custom_quiz_creator.copy_link"))
      signals.emit("kenhub.custom_quiz_copy_button_clicked", {
        user_id: quiz.user_id,
        slug: quiz.slug
      })
    }
  }

  return (
    <KenhubModal
      identifier="share_quiz"
      label={I18n.t("js.custom_quiz_creator.share_quiz_modal.title")}
      title={I18n.t("js.custom_quiz_creator.share_quiz_modal.title")}
      class_name="modal-wide share-quiz-modal"
      on_close={on_close}
      is_open={is_open}
    >
      <div className="modal-body">
        <div>
          <label htmlFor="title">
            {I18n.t("js.custom_quiz_creator.share_quiz_modal.label")}
          </label>
          <div className="input-with-cta">
            <input
              ref={ref}
              type="text"
              value={quiz.url}
              readOnly
            />
            <button
              onClick={copy_to_clipboard}
              className="btn btn-primary btn-small modal-options__option"
              data-style="zoom-out"
            >
              <FaIcon name={"fa-files"}/>
              {I18n.t("js.custom_quiz_creator.share_quiz_modal.button")}
            </button>
          </div>
        </div>
      </div>
    </KenhubModal>
  )
}

export default ShareQuizModal
